import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { ChangeDetectorRef, Component, inject, Input, NgZone, ViewChild, WritableSignal } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RecordService } from '../../record/record.service';
import { IRptIncome, IRptIncomeIns, IRptIncomeCks, IRptIncomePay } from '../../shared/interfaces/rptIncome';
import { DataMessageService } from '../../shared/data-message.service';
import { ModalService } from '../../shared/modal.service';
import { AppToastsService } from '../../shared/app-toasts/app-toasts.service';
import { ExportExcelService } from '../../shared/export-excel.service';
import { CkRegisterService } from '../../ck-register/ck-register.service';
import { MatDialog } from '@angular/material/dialog';

interface IExpandedCol {
  index: number;
  show: boolean;
  claims: IRptIncomeCks[];
}

@Component({
  selector: 'app-rpt-income',
  // imports: [],
  templateUrl: './rpt-income.component.html',
  styleUrl: './rpt-income.component.css',
  standalone: false
})
export class RptIncomeComponent {
  _recordService = inject(RecordService);
  _cd = inject(ChangeDetectorRef);
  _ngZone = inject(NgZone);
  _ngbModal = inject(NgbModal);

  @Input() rptIncomeData!: WritableSignal<IRptIncome>;
  @Input() rptFromDt: WritableSignal<string> | undefined;
  @Input() rptToDt: WritableSignal<string> | undefined;
  @Input() rptOptions: WritableSignal<any[]> | undefined;
  @Input() seldProvsIDs: WritableSignal<string> | undefined;
  @Input() seldInses1IDs: WritableSignal<string> | undefined;
  @Input() seldInses2IDs: WritableSignal<string> | undefined;
  @Input() seldFacsIDs: WritableSignal<string> | undefined;
  @Input() seldLocalesNo: WritableSignal<string> | undefined;
  @Input() espIncome: WritableSignal<string> | undefined;
  @Input() sioQuery!: WritableSignal<string | null>;
  @Input() incomeTot: WritableSignal<string> | undefined;
  @Input() spinner: WritableSignal<boolean> | undefined;

  @ViewChild(MatSort) sort: MatSort | undefined;
  @ViewChild('vp', { static: false }) vp!: CdkVirtualScrollViewport;

  sn!: string;
  engLang!: boolean;
  userID!: string;
  userLastNm!: string;
  userFirstNm!: string;

  modalStack: string[] = [];

  activeView: string = ''; // Holds the currently selected view name
  insurance: IRptIncomeIns[] = [];
  check: IRptIncomeCks[] = [];
  payment: IRptIncomePay[] = [];
  showClaims: IExpandedCol[] = []; // Array to track which rows have details expanded
  insPrintAll: boolean = false; // For printing all ins,clm,det,pay as displayed; WARNING: can yield a memory (to much data) error in JSReports
  insPrintAllInsOnly: boolean = false; // For printing all only insurances

  constructor(private _dataMessageService: DataMessageService,
    private _modalService: ModalService,
    private _appToastsService: AppToastsService,
    private _ckRegisterService: CkRegisterService,
    private _xcel: ExportExcelService,
    public _dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this._dataMessageService.currentSnStr.subscribe(snStr => this.snChange(snStr)); // Subscription looking for changes in sn
    this._dataMessageService.currentEngLangStr.subscribe(engLangStr => this.engLangChange(engLangStr)); // Subscription looking for changes in engLang
  }

  snChange(snStr: string) { // for when sn changes
    this.sn = snStr;
  }

  engLangChange(engLangStr: string) { // for when language changes
    engLangStr === 'true' ? this.engLang = true : this.engLang = false;
  }

  engIncomeDescr(vname: string): string {
    if (this.engLang) {
      const map: { [key: string]: string } = {
        "Cobros:": "Income:",
        " a ": " to ",
        " pedido ": " requested "
      };
      const re = /Esp vs Cob:| a | pedido /g;
      return vname.replace(re, m => map[m]);
    }
    return vname; // Spanish version
  }

  onChange_view(event: string) {  // Loads up an existing view in event
    this.activeView = event; // Set the active view to the selected one
    this.rptIncomeData.update(current => ({
      views: current.views,
      parm: [],
      ins: [],
      cks: [],
      pay: [],
      tot: {
        InID: '',
        InLNm: 'Total',
        shoInID: '',
        Usual: '0',
        Xpected: '0',
        AdjPos: '0',
        Payed: '0',
        AdjNeg: '0',
        IBal: '0',
        Pvdo: '0',
        PPayed: '0',
        PDisc: '0',
        PBal: '0',
        Cnt: '0'
      }
    }));
    this.espIncome?.set(''); // Reset dtxTot when changing views (guard when espCobTot is undefined)
    this.showClaims = []; // Reset showClaims array when changing views

    const qry = "EXEC dbo.spRptDtx @viewNm = '" + this.activeView + "';";
    window.scroll(0, 0);
    console.log('%c' + 'query ' + qry, 'color: green; background: yellow; font-size: 12px');
    this.sioQuery.set(qry);
  }

  private waitForPaint(): Promise<void> { // Paint the spinner
    return new Promise<void>((resolve) => {
      requestAnimationFrame((_t1) => {
        requestAnimationFrame((_t2) => resolve());
      });
    });
  }

}
